import React from 'react';

const styles = {
  container: {
    position: 'relative',
    minHeight: '100vh',
    width: '100%',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  
  // Layer 1: Brick wall background (repeating)
  brickWall: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundImage: 'url(/images/auth/brick-wall.jpg)',
    backgroundRepeat: 'repeat',
    backgroundSize: 'auto', // Let it tile naturally
    zIndex: 1,
  },
  
  // Layer 2: Living room furniture
  furniture: {
    position: 'absolute',
    bottom: 0,
    left: '50%',
    transform: 'translateX(-50%) scaleX(1.085)', // Stretch horizontally by 8% (adjust as needed)
    width: '1920px', // Fixed width matching your design
    height: 'auto',
    maxWidth: '100%',
    zIndex: 2,
  },
  
  // Layer 3: Ceiling lamps (scaled down to 50%)
  lamps: {
    position: 'absolute',
    top: 0,
    left: '50%',
    transform: 'translateX(-50%) scale(0.5)',
    transformOrigin: 'top center',
    width: '1920px', // Fixed width matching your design
    height: 'auto',
    maxWidth: '100%',
    zIndex: 3,
    pointerEvents: 'none', // Allow clicks to pass through
  },
  
  // Layer 4: Form container (positioned where the white area should be)
  formContainer: {
    // position: 'relative',
    position: 'absolute',
    top: 50,
    zIndex: 4,
    width: '400px',
    minHeight: '400px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    // Adjusted to move form up now that top logo is removed
    // marginTop: '-420px', // Fine-tune vertical position
    marginLeft: '0px', // Fine-tune horizontal position
  },
  
  // The white form background
  formBackground: {
    backgroundColor: 'white',
    padding: '40px',
    borderRadius: '8px',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
    width: '100%',
    maxWidth: '400px',
  },
  
  // Title styling
  title: {
    textAlign: 'center',
    marginBottom: '30px',
    fontSize: '24px',
    fontWeight: 'bold',
    color: '#333',
  },
  
  // Logo inside form
  formLogo: {
    width: '80px',
    height: 'auto',
    margin: '0 auto 20px',
    display: 'block',
  },
};

export const AuthLayout = (props) => {
  const { children } = props;
  
  return (
    <div style={styles.container}>
      {/* Layer 1: Brick wall background */}
      <div style={styles.brickWall} />
      
      {/* Layer 2: Furniture (bookcase, couch, curtains) */}
      <img 
        src="/images/auth/furniture.png" 
        alt="" 
        style={styles.furniture}
      />
      
      {/* Layer 3: Ceiling lamps */}
      <img 
        src="/images/auth/lamps.png" 
        alt="" 
        style={styles.lamps}
      />
      
      {/* Layer 4: Form */}
      <div style={styles.formContainer}>
        <div style={styles.formBackground}>
          <img 
            src="/images/auth/loerie-icon.png" 
            alt="Loerie" 
            style={styles.formLogo}
          />
          <h2 style={styles.title}>DIE LOERIEWEB</h2>
          {children}
        </div>
      </div>
    </div>
  );
};
